// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelDisabled-DisabledReason_cls1__mcNlg","cls2":"PaymentChannelDisabled-DisabledReason_cls2__1nZN2 PaymentChannelDisabled-DisabledReason_cls1__mcNlg"};